import React from 'react'
import { ATLAtomIcon } from '@appsimples/atlantica-react-native'
import { icons } from '../../constants/searchAssets'
import { atlTheme } from '../../atlTheme'
import { TouchableHighlight } from 'react-native'
import styled from 'styled-components/native'

const Row = styled.View`
  flex-direction: row;
  padding: ${atlTheme.SpacingBase}px 0px;
`
const DocumentTitle = styled.Text`
  color: ${atlTheme.ColorHighContrast};
  font-family: ${atlTheme.FontFamilyBrand};
  font-style: normal;
  font-weight: ${atlTheme.FontWeight500};
  font-size: ${atlTheme.FontSizeBody}px;
  line-height: ${atlTheme.LineHeightBase}px;
  margin-left: ${atlTheme.SpacingMarginal}px;
  width: 85%;
`
interface ConstructionDocumentListItemProps {
  text: string
  onPress: () => void
}

export const ConstructionDocumentListItem: React.FunctionComponent<ConstructionDocumentListItemProps> = props => {
  return (
    <Row>
      <DocumentTitle>{props.text}</DocumentTitle>
      <TouchableHighlight onPress={props.onPress} underlayColor={'transparent'}>
        <ATLAtomIcon source={icons.download} />
      </TouchableHighlight>
    </Row>
  )
}
